import { styled } from "@mui/material/styles";
import Tooltip, { tooltipClasses, TooltipProps } from "@mui/material/Tooltip";
import themeConfig from "../../theme/themeConfig.json";

// Shared by direct action buttons and the actions inside a menu.
const ActionTooltip = styled(({ className, ...props }: TooltipProps) => (
  <Tooltip {...props} classes={{ popper: className }} />
))(({ theme }) => ({
  [`& .${tooltipClasses.tooltip}`]: {
    maxWidth: "calc(100vw - 24px)",
    boxSizing: "border-box",
    display: "flex",
    alignItems: "center",
    padding: "16px 20px",
    border: "1px solid #E2E8F0",
    borderRadius: 10,
    backgroundColor: theme.palette.background.paper,
    color: theme.palette.text.primary,
    boxShadow: themeConfig.shadows.card,
    fontSize: "1rem",
    fontWeight: 400,
    lineHeight: 1.6,
    overflowWrap: "anywhere",
  },
  [`&&[data-popper-placement] .${tooltipClasses.tooltip}`]: {
    margin: 0,
  },
  [`& .${tooltipClasses.arrow}`]: {
    color: theme.palette.background.paper,
    "&::before": { border: "1px solid #E2E8F0" },
  },
}));

export default ActionTooltip;
